import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";
import { APIURL, CLIENT_ID, MSTENANT, SCOPE } from './config'
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import 'formiojs/dist/formio.full.min.css';

const msalInstance = new PublicClientApplication({
    auth: {
        clientId: CLIENT_ID,
        authority: MSTENANT
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    }
});

await msalInstance.initialize();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App instance={msalInstance} />
    </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
